import { transparentize } from 'polished';
import styled from 'styled-components';

interface ContainerProps {
  checked: boolean;
}

export const Container = styled.button<ContainerProps>`
  font-family: 'Sora';
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 15px;
  padding-bottom: 20px;
  gap: 8px;
  background: white;
  border: 2px solid
    ${({ theme, checked }) =>
      checked ? theme.colors.main : theme.colors.lightGrey};
  border-radius: 6px;

  .icon-container {
    width: fit-content;
    padding: 8px;
    border-radius: 50%;
    background-color: ${({ theme }) => transparentize(0.9, theme.colors.main)};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.main};
  }

  .content {
    h3 {
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      color: ${({ theme }) => theme.colors.black};
      margin-bottom: 5px;
    }

    h4 {
      text-align: center;
      font-size: 12px;
      color: ${({ theme }) => theme.colors.grey};
    }
  }

  .badge {
    background: ${({ theme }) => theme.colors.main};
    color: ${({ theme }) => theme.colors.white};
    padding: 2px 8px;
    border-radius: 50px;
    font-size: 11px;
    font-weight: 600;
    position: absolute;
    bottom: -10px;
  }

  .here {
    background: ${({ theme }) => theme.colors.white};
    border: 2px solid ${({ theme }) => theme.colors.main};
    color: ${({ theme }) => theme.colors.main};
    padding: 2px 8px;
    border-radius: 50px;
    font-size: 11px;
    font-weight: 600;
    position: absolute;
    top: -10px;
  }

  .check {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    position: absolute;
    top: 6px;
    right: 6px;
    color: ${({ theme }) => theme.colors.white};

    &.checked {
      background-color: ${({ theme }) => theme.colors.main};
    }

    &.unchecked {
      background-color: ${({ theme }) => theme.colors.white};
      border: 2px solid ${({ theme }) => theme.colors.lightGrey};
    }
  }
`;
